import type { TodayVisit } from "./visitsClient";

// Kept free of visitsClient's API-client import chain; consumers use visitsClient's re-exports.

export const isVisitCancelled = (visit: TodayVisit): boolean =>
  visit.cancelledAt !== null;

export const isConfirmedIn = (visit: TodayVisit, roomUuid: string): boolean =>
  visit.roomConfirmation?.roomId === roomUuid;
